import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PasswordModule } from 'primeng/password';
import { ReactiveFormsModule } from '@angular/forms';
import { AppPasswordResetDialogComponent } from './app-password-reset-dialog.component';

@NgModule( {
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    PasswordModule,
    ReactiveFormsModule,
    AppPasswordResetDialogComponent,
  ],
  exports: [AppPasswordResetDialogComponent]
} )
export class AppPasswordResetDialogModule {}